import { IdentityRepository } from '@model/identity';

/**
 * Caso de uso para cerrar la sesión del usuario
 */
export class FullLogoutUseCase {
  /**
   * Constructor del caso de uso
   * @param _identityRepository Repositorio de seguridad
   */
  constructor(private _identityRepository: IdentityRepository) {}

  /**
   * Método que ejecuta el caso de uso
   * @param fullUrlLogout URL de logout completo
   */
  execute(): void {
    // Limpiamos la sesión local antes de hacer el logout
    this._identityRepository.clearLocalSession();
    this._identityRepository.fullLogout();
  }
}
